import { useEffect } from "react";

const BASE = "Ninersbillard";

export function usePageTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : `${BASE} | Sportsbar, Billard & Dart in Wels`;
    return () => { document.title = `${BASE} | Sportsbar, Billard & Dart in Wels`; };
  }, [title]);
}
